



















































































import { Component, Prop, Vue } from 'vue-property-decorator';
import { Action, Getter, State } from 'vuex-class';
import DropdownInputElement from '../../ui/form/elements/DropdownInputElement.vue';
import BaseNumberInputElement from '../../ui/form/numberinput/BaseNumberInputElement.vue';
import VueSmartSlider from '../../ui/slider/VueSmartSlider.vue';
import { SliderMarker } from '../../ui/slider/types/SliderTypes';
import {
  DashboardState,
  GetServerRequest,
  GetServerResponse,
  UpdateServerRequest,
} from '../../../store/dashboard/types';
import { MutationRequestStatus } from '../../../store/types';
import LoadingAnimation from '../../helper/LoadingAnimation.vue';
import { calculateSliderSteps } from '../../../service/slider';
import BaseAppModal from '../BaseAppModal.vue';
import { CustomInputValidationState } from '../../ui/form/numberinput/BaseNumberInputElementFeatures';
import { Customer } from '../../../store/auth/types';
import { CloudUnitType } from '../../../store/product/types';
// @TODO: replace with composition API and rename to BaseEditUnits to match the Vue Styleguide

@Component({
  components: {
    BaseAppModal, LoadingAnimation, VueSmartSlider, BaseNumberInputElement, DropdownInputElement,
  },
})
export default class EditUnits extends Vue {
  // @TODO: refactor the computed properties to make use of vuex getters
  @Action('dashboard/getServer') readonly requestServer!: (request: GetServerRequest) => Promise<GetServerResponse>;

  @Action('dashboard/updateServer') readonly updateServer!: (request: UpdateServerRequest) => Promise<void>;

  @State('dashboard') readonly dashboard!: DashboardState;

  @Getter('dashboard/server') readonly server!: GetServerResponse;

  @Getter('auth/customer') readonly customer!: Customer;

  @Action('auth/fetchCustomer') readonly fetchCustomer!: () => Promise<void>

  @Prop({ type: Number, required: true }) readonly orderId!: number;

  name = 'EditUnits';

  units = null;

  cloudUnitType: CloudUnitType = null;

  isDataReady = false;

  isModalReady = false;

  get serverLoading(): boolean {
    return this.dashboard.getServer.status === MutationRequestStatus.LOADING;
  }

  get serverError(): boolean {
    return this.dashboard.getServer.status === MutationRequestStatus.ERROR;
  }

  get serverSuccess(): boolean {
    return this.dashboard.getServer.status === MutationRequestStatus.SUCCESS;
  }

  get updateLoading(): boolean {
    return this.dashboard.updateServer.status === MutationRequestStatus.LOADING;
  }

  get changesAllowed(): boolean {
    return this.dashboard.getServer.status === MutationRequestStatus.LOADING
      || this.dashboard.updateServer.status === MutationRequestStatus.LOADING;
  }

  get minUnits(): number {
    return Math.min.apply(Math, Object.entries(this.server.units).map(([, value]) => value));
  }

  get maxUnits(): number {
    return Math.max.apply(Math, Object.entries(this.server.units).map(([, value]) => value));
  }

  get isUnitInputValid(): CustomInputValidationState {
    return {
      customValid: this.unitInputValidator(this.units),
      customErrorMessage: this.$t('modal:edit_units.slot_input.validation_error'),
    };
  }

  /**
   * for some unknown reason the backend responds with way to much "units" to display,
   * (i counted 60 for specific games)
   * we have to break it down here
   */
  get sliderMarker(): Array<SliderMarker> {
    return calculateSliderSteps(this.minUnits, this.maxUnits);
  }

  get isConfirmDisabled() {
    return !this.unitInputValidator(this.units);
  }

  unitInputValidator(units: number): boolean {
    return this.serverSuccess && units >= this.minUnits && units <= this.maxUnits;
  }

  onEditUnitsAccept(): void {
    if (!this.unitInputValidator(this.units)) {
      this.$toast.error(this.$t('modal:edit_units.feedback.invalid_units'));
      return;
    }

    this.updateServer({
      orderId: this.orderId,
      units: this.units,
    }).then(() => {
      this.$toast.success(this.$t('modal:edit_units.feedback.success'));
      this.$emit('close-modal');

      // @TODO: reloads the page afterwards, not required when the dashboard is a vue component
      window.setTimeout(() => document.location.reload(), 500);
    }, (errorMessage) => {
      this.$toast.success(errorMessage ?? this.$t('modal:edit_units.feedback.error'));
    });
  }

  async mounted(): Promise<void> {
    try {
      const { currentUnits, cloudUnitType } = await this.requestServer({ orderId: this.orderId });
      this.units = currentUnits;
      this.cloudUnitType = cloudUnitType;
    } catch (error) {
      throw new TypeError(error);
    }

    if (this.customer == null) {
      await this.fetchCustomer();
    }

    this.isDataReady = true;
  }
}
